export default {
    registration: 'KzРегистрация',
};